<div *ngIf="loading" class="comp-loader">
	<lib-loading></lib-loading>
</div>
<div *ngIf="!loading">
  <div class="container">
    <div class="banner">
      <img [src]="urlBanner" alt="Banner Lopes">
    </div>
  </div>
  <lib-tabs 
    [tabs]="tabs" 
    [tabAlign]="2" 
    (selectTab)="selectTab($event)">
  </lib-tabs>
  <router-outlet></router-outlet>
</div>
